import React from 'react';
import type { Color } from '../../styles/variables';
import { COLORS } from '../../styles/variables';

interface ArrowUpIconProps {
  size?: number;
  color?: Color;
}

const ArrowUpIcon: React.FC<ArrowUpIconProps> = ({ color = COLORS.black, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 15.5L12.5 10 7 15.5"
      stroke={color}
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
);

export default ArrowUpIcon;
